/* eslint-disable */
export interface IActivityItemOptions extends Partial<HTMLAnchorElement> {
	icon?: HTMLElement | SVGElement;
	middleHTML: string;
	buttons?: HTMLElement;
}

export function createActivityItem({
	className = "",
	icon,
	middleHTML = "",
	buttons,
	...rest
}: Partial<IActivityItemOptions>): HTMLAnchorElement {
	const link = Mapy.Util.node("a", {
		className: `ui-activity-item ${className}`,
		...rest,
	}) as HTMLAnchorElement;
	const iconContainer = Mapy.Util.node("div", { className: "ui-activity-item--left" }) as HTMLDivElement;

	icon && iconContainer.appendChild(icon);
	link.appendChild(iconContainer);
	link.appendChild(Mapy.Util.node("div", { className: "ui-activity-item--middle", innerHTML: middleHTML }) as HTMLDivElement);

	if (buttons) {
		const buttonsContainer = Mapy.Util.node("div", { className: "ui-activity-item--right" }) as HTMLDivElement;

		buttonsContainer.appendChild(buttons);
		link.appendChild(buttonsContainer);
	}

	return link;
}
